import React, { createContext, useState, useContext } from "react";
import { useSearch } from "./SearchContext";
import useRequest from "../hooks/useRequest";
import apiPath from "../constants/apiPath";

// Create a context for notifications
const NotificationContext = createContext();

export const useNotification = () => {
  return useContext(NotificationContext);
};

export const NotificationProvider = ({ children }) => {
  const [unread, setUnread] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [filter, setFilter] = useState(null);
  const { searchTerm } = useSearch();
  const [loading, setLoading] = useState(false);
  const { request } = useRequest();

  const fetchNotifications = () => {
    setLoading(true);
    const queryParams = new URLSearchParams();

    if (filter !== null) queryParams.append("is_read", filter);
    if (searchTerm) queryParams.append("search", searchTerm);

    request({
      url: `${apiPath.notification}/list?${queryParams.toString()}`,
      method: "GET",
      onSuccess: (data) => {
        setNotifications(data.data.list || []);
        //   const unread = data.data.list.filter((notif) => !notif.is_read);
        //   setUnread(unread);

        const unread = data.data.list.some(
          (notification) => !notification.is_read
        );
        setUnread(unread);
      },
      onError: (error) => console.error("Error fetching notifications:", error),
    }).finally(() => setLoading(false));
  };

  return (
    <NotificationContext.Provider
      value={{ unread, notifications, fetchNotifications }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
